<!-- 图文详情 -->
<template>
    <div v-if="componentsData.type == 8" class="bg-div"
        :style="componentsData.content.version ?
            {
                ...(componentsData.content.bg_color && { backgroundColor: componentsData.content.bg_color }),
                ...(componentsData.content.bg_img.picview && componentsData.content.bg_value && { backgroundImage: `url(${componentsData.content.bg_img.picview})` }),
                padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`
            } : 
            `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
        "
    >
        <div class="ql-editor" v-html="componentsData.content.text"></div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>

<style>
.ql-editor {
    padding: 0 !important;
}
.ql-editor img {
    width: 100% !important;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
</style>